<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
              首页
            </router-link>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              <span class="font-semibold text-psychology-primary">{{ assessmentType === 'self' ? '给自己测' : '为恋人测' }}</span>
            </div>
          </div>
        </div>

        <!-- 整体进度条 -->
        <div class="mt-4">
          <div class="flex justify-between items-center mb-2">
            <span class="text-sm text-gray-600">整体进度</span>
            <span class="text-sm font-medium">100%</span>
          </div>
          <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
            <div class="h-full bg-psychology-primary transition-all duration-500" style="width: 100%;"></div>
          </div>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-2xl mx-auto text-center">
        <div class="card p-12">
          <div class="space-y-6">
            <!-- 动画图标 -->
            <div class="w-16 h-16 bg-psychology-primary/10 rounded-full flex items-center justify-center mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-primary animate-pulse">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
            </div>

            <!-- 标题 -->
            <div>
              <h2 class="text-2xl font-bold text-psychology-primary mb-2">正在分析{{ assessmentType === 'self' ? '您的' : 'Ta的' }}回答</h2>
              <p class="text-gray-600">我们正在使用科学算法计算{{ assessmentType === 'self' ? '您的' : 'Ta的' }}恋爱占有欲指数，请稍候...</p>
            </div>

            <!-- 进度条 -->
            <div class="space-y-3">
              <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
                <div class="h-full bg-psychology-primary animate-progress"></div>
              </div>

              <!-- 步骤列表 -->
              <div class="space-y-2 pt-4">
                <div 
                  v-for="(step, index) in steps" 
                  :key="index"
                  class="flex items-center justify-center gap-2 text-sm transition-all duration-500"
                  :class="currentStep >= index ? 'text-gray-900' : 'text-gray-400'"
                >
                  <svg 
                    v-if="currentStep > index"
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="w-4 h-4 text-green-500"
                  >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11 3 3L22 4"></path>
                  </svg>
                  <svg 
                    v-else-if="currentStep === index"
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="w-4 h-4 text-psychology-primary animate-spin"
                  >
                    <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                  </svg>
                  <svg 
                    v-else
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="w-4 h-4 text-gray-300"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                  <span>{{ step }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { questionnaireData } from '../data/questions.js'
import { calculateResults, generateRecommendations, generateExpertRecommendations } from '../utils/resultCalculator.js'
import { createSession, completeSession, migrateOldData, getSessionById } from '../utils/sessionStorage.js'
import { useToast } from 'vue-toastification'

export default {
  name: 'CalculatingPage',
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      assessmentType: 'self',
      currentStep: 0,
      steps: [
        '应用四维度标准化算法',
        '生成个性化分析报告',
        '保护您的隐私数据'
      ],
      sessionId: null
    }
  },
  mounted() {
    this.assessmentType = this.$route.query.type || 'self'
    this.sessionId = this.$route.query.sessionId
    this.startCalculation()
  },
  methods: {
    async startCalculation() {
      try {
        // 迁移旧数据（如果存在）
        migrateOldData()
        
        let answers = {}
        let basicInfo = {}
        
        if (this.sessionId) {
          // 从会话获取数据
          const session = getSessionById(this.sessionId)
          if (session) {
            answers = session.responses || {}
            basicInfo = session.demographics || {}
            console.log('Using data from session:', this.sessionId)
          } else {
            this.toast.error('会话不存在，请重新开始测评')
            this.$router.push('/')
            return
          }
        } else {
          // 向后兼容：从localStorage读取数据
          const storageKey = `rpi_answers_${this.assessmentType}`
          answers = JSON.parse(localStorage.getItem(storageKey) || '{}')
          basicInfo = JSON.parse(localStorage.getItem('rpi_basic_info') || '{}')
          
          if (Object.keys(answers).length === 0) {
            this.toast.error('未找到测评数据，请重新开始测评')
            this.$router.push('/')
            return
          }
          
          // 创建新会话
          const session = createSession({
            type: this.assessmentType,
            demographics: basicInfo,
            responses: answers
          })
          this.sessionId = session.id
        }
        
        const zodiacSign = basicInfo.zodiac || basicInfo.zodiacSign || 0
        
        // 模拟计算过程，每秒切换一个步骤
        const stepInterval = setInterval(() => {
          if (this.currentStep < this.steps.length - 1) {
            this.currentStep++
          }
        }, 800)

        // 在计算过程中进行实际计算
        setTimeout(async () => {
          try {
            // 计算结果
            const result = calculateResults(answers, questionnaireData, this.assessmentType, zodiacSign)
            
            // 生成建议
            const recommendations = generateRecommendations(result)
            const expertRecommendations = generateExpertRecommendations(result)
            
            // 完善结果数据
            const completeResult = {
              ...result,
              recommendations,
              expertRecommendations,
              sessionId: this.sessionId,
              endTime: new Date().toISOString(),
              totalQuestions: Object.keys(answers).length
            }
            
            // 完成会话
            completeSession(this.sessionId, completeResult)
            
            // 清理答题数据
            const storageKey = `rpi_answers_${this.assessmentType}`
            localStorage.removeItem(storageKey)
            localStorage.removeItem('rpi_assessment_progress')
            localStorage.setItem('rpi_assessment_completed', 'true')
            
            clearInterval(stepInterval)
            
            // 跳转到结果页，带上sessionId
            this.$router.push({
              path: '/assessment/result',
              query: { sessionId: this.sessionId }
            })
            
          } catch (error) {
            console.error('计算失败:', error)
            clearInterval(stepInterval)
            this.toast.error('计算过程中发生错误，请重试')
            this.$router.push('/')
          }
        }, 2000) // 2秒后开始计算
        
      } catch (error) {
        console.error('初始化失败:', error)
        this.toast.error('初始化失败，请重试')
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
/* 进度条动画 */
@keyframes progress {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.animate-progress {
  animation: progress 1.5s ease-in-out infinite;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(139, 92, 246, 0.5) 50%, 
    transparent 100%
  );
}

/* 心形图标脉冲动画 */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* 旋转动画 */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>

